import { classnames } from '@aibees/shared/utils';
import { Box, Tab, Tabs } from '@mui/material';
import { memo, useCallback } from 'react';
import * as SX from './sx';
import type { ClientsCommentsTabsProps as Props } from './types';
import { TestimonialFilter } from '../../types';
import { Label } from '@aibees/shared/components';

const TAB_OPTIONS: { value: TestimonialFilter; label: string }[] = [
  { value: TestimonialFilter.ALL, label: 'All' },
  { value: TestimonialFilter.LEADER, label: 'Leaders' },
  { value: TestimonialFilter.LINKEDIN, label: 'LinkedIn' },
  { value: TestimonialFilter.YOUTUBE, label: 'YouTube' },
];

export const ClientsCommentsTabs = memo(
  ({ value, onChange, counts, className }: Props) => {
    const handleChange = useCallback(
      (_: unknown, next: TestimonialFilter) => {
        onChange(next);
      },
      [onChange]
    );

    return (
      <Box
        className={classnames('ClientsCommentsTabs', className)}
        sx={SX.root}
      >
        <Tabs value={value} onChange={handleChange} variant="fullWidth">
          {TAB_OPTIONS.map((opt) => (
            <Tab
              key={opt.value}
              value={opt.value}
              label={
                <Box sx={SX.tabLabel}>
                  {opt.label}
                  <Label
                    variant={opt.value === value ? 'filled' : 'soft'}
                    color={opt.value === value ? 'primary' : 'default'}
                    size="xxsmall"
                  >
                    {counts[opt.value]}
                  </Label>
                </Box>
              }
            />
          ))}
        </Tabs>
      </Box>
    );
  }
);

ClientsCommentsTabs.displayName = 'ClientsCommentsTabs';
